export default __webpack_public_path__ + "static/media/640_store03-nl-mobile.3797be89.png";